import styles from "./PageSearchResult.module.scss";
import {observer} from "mobx-react";
import ClickableLink from "../../components/utilities/ClickableLink";

type PageSearchResultProps = {
    id: string,
    title: string,
    url: string,
    content: string,
    breadcrumbs: string,
}

const PageSearchResult = observer((props: PageSearchResultProps) => {
    return (
        <li className={styles.result}>
            <section>
                <ClickableLink href={props.url}>
                    <div>
                        <h2>{props.title}</h2>
                        <div className={styles.breadcrumbs}>
                            {props.breadcrumbs}
                        </div>
                        <div className={styles.content}>
                            <div dangerouslySetInnerHTML={{__html: props.content}}/>
                        </div>
                    </div>
                </ClickableLink>
            </section>
        </li>
    );
})

export default PageSearchResult;
